import React from 'react';
import { array, func } from 'prop-types';

import { PRESTOSOFT_URL } from '../util/constants';
import { examDiffProUrl } from '../util/common';

const linkStyle = { marginLeft: 5, textDecoration: 'underline', color: '#777777' };

// Contact us and the changelog are in the header's Help menu
const Footer = ({ openTermsOfServiceDialog, landingPages }) => (
  <div style={{ padding: 12, marginTop: 15, fontSize: 12, color: '#777' }}>
    {landingPages && landingPages.length > 0 && (
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginBottom: 6 }}>
        {landingPages.map(page => (
          // Plain links: landing pages get their text from the server on a full page load
          <a key={page.path} style={linkStyle} href={page.path}>
            {page.text}
          </a>
        ))}
      </div>
    )}
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
      <div>Copyright © 2011-{new Date().getFullYear()}</div>
      <a style={linkStyle} target="_blank" rel="noopener noreferrer" href={PRESTOSOFT_URL}>
        PrestoSoft LLC.
      </a>
      <div style={{ marginLeft: 5 }}>All rights reserved.</div>
      <div
        style={{ marginLeft: 5, textDecoration: 'underline', cursor: 'pointer' }}
        onClick={openTermsOfServiceDialog}
      >
        Terms of Service
      </div>
      <div>.</div>
      <a
        style={linkStyle}
        target="_blank"
        rel="noopener noreferrer"
        href={examDiffProUrl('diffnow-footer')}
      >
        ExamDiff Pro for Windows
      </a>
      <div>.</div>
    </div>
  </div>
);

Footer.propTypes = {
  openTermsOfServiceDialog: func,
  landingPages: array
};

export default Footer;
